import { ArrowLeft, ArrowRight } from "lucide-react";

export function PageShell({ children, section = "Tools" }) {
  return (
    <>
      <header className="page-nav" aria-label="Page navigation">
        <a className="page-nav__wordmark" href="/" aria-label="Dr. Neerja Gidwani, home">
          Dr. Neerja <span>{section}</span>
        </a>
        <a className="page-nav__cta" href={section === "Notes" ? "/notes" : "/tools"}>
          {section === "Notes" ? "All notes" : "All tools"} <ArrowRight size={16} aria-hidden="true" />
        </a>
      </header>
      {children}
      <footer className="page-footer">
        <p className="page-footer__close">With care,<br /><strong>Dr. Neerja</strong></p>
        <p>
          I’m building this library as a place to pause, prepare, and understand.
          <a href="/"><ArrowLeft size={15} aria-hidden="true" /> Return home</a>
        </p>
      </footer>
    </>
  );
}
